interface ABIParams {
  highestSystolicBrachialPressure: {
    systolic: {
      mmHg: number;
    };
  };
  highestAnklePressure: {
    mmHg: number;
  };
}

interface ABIResult {
  abi: number;
}

function calculate({
  highestAnklePressure,
  highestSystolicBrachialPressure,
}: ABIParams): ABIResult {
  return {
    abi:
      highestAnklePressure.mmHg / highestSystolicBrachialPressure.systolic.mmHg,
  };
}
export const ABI = {
  calculate,
};
